import React from 'react';
import ComplexText from '@ui/complex-text';

const ListItemDisc = ({ data }) => {
    return (
        <li className="mb-2 last:mb-0">
            <ComplexText values={data.text} />
        </li>
    );
};

const ListItemImage = ({ data }) => {
    return (
        <li className="mb-2 last:mb-0">
            <div className="flex gap-2">
                <div className="mt-[2px]">
                    <img className="w-[16px]" src={data.imageUrl} />
                </div>
                <div className="w-[90%]">
                    <ComplexText values={data.text} />
                </div>
            </div>
        </li>
    );
};

const TypeClassesHash = {
    disc: 'list-disc pl-4',
    image: '',
};

const TypeListItemHash = {
    image: (key, data) => <ListItemImage key={key} data={data} />,
    disc: (key, data) => <ListItemDisc key={key} data={data} />,
};

const HtmlList = ({ items = [], type = 'disc', className = '' }) => {
    if (!items) return null;

    const listCss = TypeClassesHash[type];

    const listItem = TypeListItemHash[type];

    if (!listItem) return null;

    return (
        <ul className={`${listCss} ${className}`}>
            {items.map((item, index) => {
                return listItem(index, item);
            })}
        </ul>
    );
};

export default HtmlList;
